
$(document).ready(function () {
var page = 1;

if (($(".lista_newsow").length > 0)) {
	
	infinteLoadMore(page);
}

$('#news_load').on('click', '.click_nextLoadPage', function() {
	console.log('aaaaaaa');
	var page = $(this).data('nextpage');
	infinteLoadMore(page);
})

function infinteLoadMore(page) {
	var id_page = $('.lista_newsow').data('id');
	$.get('/news/get-next?page='+page, {
		_token: TOKEN,
		id_page:id_page
	}).done(function (response) {
		    if (response.length == 0) {
		        return;
		    }
		    $('.hand_wiecej').remove();
		    $(".lista_newsow").append(response.view);
		})
}
		})